/* eslint-disable indent */
/* eslint-disable max-len */
import React, { useCallback, useEffect,useState,useContext,useRef } from "react"
import TopHeader from "../../components/TopHeader"
import { motion } from 'framer-motion'
import { Link } from "react-router-dom"
import moment from "moment"
import { dataService } from "../../services/data.services"
import { useParams,useLocation,useNavigate,useSearchParams } from "react-router-dom"
import { useSelector,useDispatch} from 'react-redux'
import CustomOverLay from "../../components/CustomOverLay"
import GlobalContext from "../../components/Context/GloablContext"
import AnimatedButton from "../../components/Animation/AnimatedButton"
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import { useGetOrganizationQuery } from "../../features/organizationSlice"
import AnimatedList from "../../components/Animation/AnimatedList"
import SearchEmptyScreen from "../../components/SearchEmptyScreen"
import SubDivTable from "./Components/SubDivTable"
import { handleIsUserScreen, handleViewOrgId } from "../../redux/systemConfigSlice"
import formatMobileNumber from "../../CommonMethods/FormatMobileNumber"
import { convertEpochToDateFormat } from "../../CommonMethods/DateConversion"
import AnimatedModel from "../../components/Animation/AnimatedModel"
import EditSubDivModal from "../../components/SubDivOrgModal"
import { handleIsAddModal, resetOrgList } from "./usersSlice"
import { handleIsMonitorAddModal, resetMonitorList } from "./monitorsSlice"
import { resetProviderList } from "./providersSlice"
import { handleEditMessageSent } from "../../redux/systemConfigSlice"
import HelpGuideModal from "../../components/HelpGuideModal"
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'
import { resetOrganizationSearch } from "../../redux/organizationSearchSlice"
import { resetPatientSearch } from "../../redux/patientSearchSlice"

export default function ViewOrganization(){
    const navigate=useNavigate()
    const dispatch=useDispatch()
    const [searchParams,setSearchParams] =useSearchParams()
    const {isSideBar,setToastErrorMessage, setToastmessage,editSocket,sendMessageToStartEditing,setIsAdvancedSearchOpen} = useContext(GlobalContext)
    const location=useLocation();
    const [viewOrganizationDetails,setViewOrganizationDetails]=useState("");
    const [loading,setLoading]=useState(true)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const [isChangeStatusOPen,setIsChangeStatusOpen]=useState(false)
    const [isHover,setIsHover]=useState(false)
    const outSideClick = useRef();
    const [index,setIndex]=useState('')
    const [confirmation,setConfirmation] = useState(false)
    const [isAddSubDiv,setIsAddSubDiv] = useState(false)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    

    let date=''
    const {id}=useParams()
    const {data,isFetching,status}=useGetOrganizationQuery(id,{ refetchOnMountOrArgChange: true})
    useEffect(()=>{
    
      if(data!==undefined){
        setViewOrganizationDetails(data);
        dispatch(handleIsUserScreen([id,data?.organization_id]));
        dispatch(handleViewOrgId(id));
      }
    },[data])



    const ref=useRef()
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })

    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    }) 

    function onEditButtonClick(index){
        setIndex(index)
        setConfirmation(true)
    }

    const handleSearchClose = () => {
        setIsAdvancedSearchOpen(false);        
        dispatch(resetOrganizationSearch());
        dispatch(resetPatientSearch());
    }

    const handleNavigationToEditPage = () => {
        if(!messageSent){
            sendMessageToStartEditing(viewOrganizationDetails?.organization_id)
            let message
            editSocket.onmessage = (event) =>{
                message = event.data
         
                if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                    navigate(`/manage-organizations/add-organization/${id}`,{state:[location.state,true,id]}),
                    handleSearchClose()
                } else{
                    dispatch(handleEditMessageSent(false))
                    { (JSON.parse(message)?.adminId) &&
                        setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this organization`)
                    }
                    
                }
            }    
        }
}
    date=convertEpochToDateFormat(data?.created_at,dateformat)
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-view-organization');
        } else {
            setQueryParamsadmin('type=admin-view-organization');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    return(
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Organizations"}/>
                {/* isFetching&&status!=="fulfilled" */}
                {isFetching&&status!=="fulfilled"?<CustomOverLay Active text="Loading Organizations Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar?'opened-sidebar-config':'system_config_overlay'}`}/>:status==="rejected"?<SearchEmptyScreen text={"No data found"} />:<>

                    <div className='bg-white rounded-lg py-[12px] h-customh3'>
                        <motion.div 
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{duration:0.5}}
                        >
                            <div className='bg-white'>
                                <div className="px-[30px]">
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-organizations" state={Array.isArray(location.state)?'':location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Organizations</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Organization</h1>
                                        {
                userType !=='super-admin' &&
                <span   onClick={() => setHelpGuideModel(true)} className='ml-auto mr-6 min-w-fit cursor-pointer'>
                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                </span> 
            }
                
                                    </div>
                                    <div className="flex items-center justify-between pb-3 pr-6">
                                        <Link to={'/manage-organizations'} state={Array.isArray(location.state)?'':location.state} className='flex items-center min-w-max'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </Link>
                                        <h1 className='text-xl font-normal text-[#000000] text-center'>
                                            View Organization 
                                        </h1>
                                        <div className="flex items-center">
                                            <button type="button" onClick={() => { handleNavigationToEditPage()}} id="edit" className={`min-w-max px-4 py-2 border border-[#972E4C] h-fit rounded-[16px] flex items-center`}>
                                                <span className='w-5'><img src="/images/edit_icon.svg" alt="icon"/></span>
                                                <span className='pl-2.5 text-lg font-normal text-[#972E4C]'>Edit</span>
                                            </button>
                                            <div className='relative ml-4'>
                                                <button data-testid="ations" id="threedot" className={`rounded-[15px] border border-[#972E4C] px-[13px] py-[10px] hover:bg-[#972E4C] focus:bg-[#972E4C] `}
                                                    onClick={()=>{setIsChangeStatusOpen(!isChangeStatusOPen)}}
                                                    onMouseEnter={() => setIsHover(true)}
                                                    onMouseLeave={() => setIsHover(false)}
                                                >
                                                    {
                                                        isHover || isChangeStatusOPen ? <img src="/images/3dots_white.svg" alt="img" /> :  <img src="/images/3_dots_color.svg" alt="img"  />

                                                    }
                                                </button>
                                                {isChangeStatusOPen&&<ul ref={ref} className='p-4 rounded-[12px] rounded-tr-none rounded-br-none absolute top-12 right-5 bg-[#fff] min-w-max shadow-s3 z-[2] '>
                                                    <li>
                                                        <ul className="max-h-[250px] overflow-auto scrollbar_purple pr-2">
                                                            <li className=" hover:bg-[#EDD7E1] rounded-lg">
                                                                <AnimatedButton
                                                                    handleClick={(e) => {navigate('/manage-organizations/activity_history',{state:[viewOrganizationDetails?.organization_id,id]}),handleSearchClose()}}
                                                                    buttonName={"View Activity History"}
                                                                    disabled={false}
                                                                    className={`px-3 py-2.5 text-base font-normal  text-[#000000] cursor-pointer hover:text-[#972E4C]`} />
                                                            </li>
                                                            <li className='hover:bg-[#EDD7E1] rounded-lg'>
                                                                <AnimatedButton
                                                                    datatestid="orgranization-user"
                                                                    handleClick={(e) => {navigate('/manage-organizations/manage-organization-users',{state:[id]}),handleSearchClose()}}
                                                                    buttonName={"Manage Organization Users"}
                                                                    disabled={false}
                                                                    className={`px-3 py-2.5 text-base font-normal  text-[#000000] cursor-pointer hover:text-[#972E4C]`} />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="pl-[30px] pr-4">
                                    <div className="flex items-center pl-[28px]">
                                        <p className="text-xl font-semibold text-[#000000]">{viewOrganizationDetails?.organization_name}</p>
                                        <p className="text-sm font-normal text-[#000000] pl-3.5">{viewOrganizationDetails?.organization_id}</p>
                                    </div>
                                    <div className="">
                                        <div className="mt-3 w-full px-6 pb-[12px] h-[calc(100vh-297px)] overflow-auto scrollbar_purple pr-2.5">
                                            <div className="mt-4 bg-[#E7EAF4] rounded-lg pt-[30px] pb-[22px] px-5">
                                                <div className="flex -mx-1 flex-wrap">
                                                    <div className="xl:w-1/4 w-1/3 px-1 mb-[30px]">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Main Number</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewOrganizationDetails?.organization_main_country_code} {formatMobileNumber(viewOrganizationDetails.main_number)}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-3/4 w-2/3 px-1 mb-[30px]">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Address</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewOrganizationDetails?.organization_address !== '' ? viewOrganizationDetails.organization_address : '-'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/4 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Direct Billing</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewOrganizationDetails?.direct_billing === false ? "False" : "True"}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/4 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Value Added</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {viewOrganizationDetails?.value_added === false ? "False" : "True"}</p>
                                                        </div>
                                                    </div>
                                                    <div className="xl:w-1/4 w-1/3 px-1">
                                                        <div className="w-full">
                                                            <p className="text-sm font-normal text-[#000]">Created Date</p>
                                                            <p className="text-base text-normal text-[#000B17] pt-2 break-words">
                                                                {date}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <SubDivTable viewOrganizationDetails={viewOrganizationDetails} viewOrg={true} id={id} onEditButtonClick={onEditButtonClick} confirmation={confirmation} handleSearchClose={handleSearchClose}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
            </div>

            {confirmation && 
            <AnimatedModel key="edit-model"
                Children={
                    <EditSubDivModal
                        handleOnCLickActivate={''}
                        handleClose={() => {setIsAddSubDiv(false),setConfirmation(false),dispatch(handleIsAddModal([''])),dispatch(handleIsMonitorAddModal([''])),dispatch(resetOrgList()),dispatch(resetMonitorList()),dispatch(resetProviderList())}}
                        data={isAddSubDiv?undefined:data?.sub_divisions[index]}
                        organization_id={data?.organization_id}
                        add={isAddSubDiv}
                        buttonName = {`Save & Apply`}
                        loadingActivation={false}
                        setConfirmation={setConfirmation}
                    />
                }
            />  
            }
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </>
    )
}